
export const app = {
	// populate from envs
	uat: process.env.NEXT_PUBLIC_SITE_URL !== 'https://vclinic.io' && process.env.NEXT_PUBLIC_SITE_URL !== 'https://vclinic.ir',
	production: process.env.NEXT_PUBLIC_SITE_URL === 'https://vclinic.io' || process.env.NEXT_PUBLIC_SITE_URL === 'https://vclinic.ir',

	site_url: process.env.NEXT_PUBLIC_SITE_URL,
	api_base_url: process.env.NEXT_PUBLIC_API_BASE_URL,
	api_base_url_v2: process.env.NEXT_PUBLIC_API_BASE_URL_V2,
	nest_api_base_url: process.env.NEXT_PUBLIC_NEST_API_BASE_URL,
	node_api_base_url: process.env.NEXT_PUBLIC_NODE_API_BASE_URL,
	doctor_image_base_url: process.env.NEXT_PUBLIC_DOCTOR_IMAGE_BASE_URL,

	google_tag_manager_id: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
	google_analytics_id: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
	hotjar_id: process.env.NEXT_PUBLIC_HOTJAR_ID,
	debounce_delay: 1000,
};
